<template>
  <div id="app">
    <signup-form
      :dialogFormVisible="dialogFormVisible"
      :signupForm="signupForm"
      @close="dialogFormVisible=false"
      :isMobile='isMobile'
    ></signup-form>
    <el-row style>
      <el-col :span="3" :xs="0" class="grid-content"></el-col>
      <el-col  :span="18" :xs='24'>
        <el-row style="margin-bottom:30px">
          <el-col :sm="9" :xs='10'>
            <span style="font-weight: 500; font-size: xx-large; font-family: monospace;">
              <a>tryjs.online</a>
            </span>
            <span>By <a  target="_blank" href='https://sunilmore.com/'>Sunil More</a></span>
          </el-col>
          <el-col class="grid-content" :sm='10' :xs='3'></el-col>
          <el-col :sm="4" :xs='10'>
            <div style="padding-top:10px;float:right" v-if="loggedin">
              <span>Hi {{user.name}}</span> &nbsp;&nbsp;
              <a href="#" @click="logout">Logout</a>
            </div>
            <div v-else style="padding-top:10px;float:right">
              <a href="#" @click="dialogFormVisible=true;signupForm=true;return false">Signup</a>&nbsp;&nbsp;
              <a
                href="#"
                @click="dialogFormVisible=true;signupForm=false ;return false; "
              >Signin</a>&nbsp;&nbsp;
            </div>
          </el-col>
        </el-row>

        <router-view :isMobile='isMobile'/>
      </el-col>
      <el-col :span="3" :xs="0" class="grid-content"></el-col>

      <!-- <h1>tryjs.online</h1> -->
    </el-row>
  </div>
</template>

<script>
import SignupForm from "./components/SignupForm";
import api from "@/api";
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      dialogFormVisible: false,
      signupForm: false
    };
  },
  methods: {
    async logout() {
      await api.logout();
      window.location.reload();
    }
  },
  components: {
    SignupForm
  },
  computed: mapState({
    // arrow functions can make the code very succinct!
    loggedin: state => state.loggedin,
    user: state => state.user,
    isMobile: state => state.isMobile
    // display:state => !!!state.isMobile
    // passing the string value 'count' is same as `state => state.count`
  })
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue